<template>
  <div :class="$style.center">
    <ContactSales
      data-test-id="ContactSalesModal__baseModal"
      :handleChatButtonClick="handleChatButtonClick"
      :isChatLoading="isChatLoading"
      :showModal="showModal"
      v-on="$listeners"
    />
  </div>
</template>
<script>
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import ContactSales from 'client/Payments/newComponents/GrowingWithJumpCloud/ContactSales.vue';
import ContactSalesChatMixin from 'client/Pricing/ContactSalesModal/ContactSalesChatMixin';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const {
  description,
  iconName,
  location,
  section,
  text,
} = eventProperties;

const {
  pricingPage,
} = eventLocations;

export default {
  name: 'ContactSalesModal',

  EventHelper,

  components: {
    ContactSales,
  },

  mixins: [ContactSalesChatMixin],

  props: {
    showModal: {
      type: Boolean,
    },
  },

  methods: {
    handleChatButtonClick() {
      this.handlePaymentChat(() => {
        this.$options.EventHelper.triggerButtonClicked({
          [description]: 'chat with a sales rep',
          [location]: pricingPage,
          [section]: 'Contact Sales Modal',
          [text]: 'live chat',
        });
      });
    },

    handleClose() {
      this.$emit('close');
      this.$options.EventHelper.triggerIconClicked({
        [description]: 'modal is closed',
        [iconName]: 'close',
        [location]: pricingPage,
        [section]: 'Contact Sales Modal',
      });
    },
  },
};
</script>
<style module>
.center {
  text-align: center;
}
</style>
